module.exports = __webpack_public_path__ + "img/mie.9908c1ec.png";